import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import conversion from "../../assets/wito.png";
import backImage from "../../assets/fondo.png";
import CircleTorunamentAvatar from "../../utils/tournament/tournament_profile_img";
import FieldIcon from "../../utils/Register/field_icon";
import SendBtn from "../../utils/Register/send_btn";
import PartnerPopUp from "../../utils/tournament/partners";
import { jwtDecode } from "jwt-decode";
import Select from "react-select";
import CategoryPopup from "../../utils/tournament/categoryPopup";
import { showToast } from "../../components/ToastNotification";
import { HiPlus, HiTrash, HiDuplicate } from "react-icons/hi";

const CreateTeam = () => {
  const [teams, setTeams] = useState([
    {
      id: 1,
      teamName: "",
      phone: "",
      city: "",
      image: null,
      imagePreview: null,
      selectedSubcategories: [],
      selectedPartners: [],
    },
  ]);
  const [error, setError] = useState("");
  const [userId, setUserId] = useState("");
  const [partners, setPartners] = useState([]);
  const [showPartnerPopUp, setShowPartnerPopUp] = useState(false);
  const [currentTeamPartnerIndex, setCurrentTeamPartnerIndex] = useState(null);
  const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);
  const [currentTeamSubcategoryIndex, setCurrentTeamSubcategoryIndex] =
    useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const token = useSelector((state) => state.user.token);

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
    }
  }, [token]);

  useEffect(() => {
    const fetchPartners = async () => {
      if (!token) return;
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/partners`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok)
          throw new Error("Error al obtener los patrocinadores.");

        const data = await response.json();
        setPartners(
          data.map((partner) => ({ label: partner.name, value: partner.id })),
        );
      } catch (error) {
        console.error("Error:", error.message);
      }
    };

    fetchPartners();
  }, [token]);

  // Agregar nuevo equipo
  const addNewTeam = () => {
    const newId = Math.max(...teams.map((t) => t.id), 0) + 1;
    setTeams([
      ...teams,
      {
        id: newId,
        teamName: "",
        phone: "",
        city: "",
        image: null,
        imagePreview: null,
        selectedSubcategories: [],
        selectedPartners: [],
      },
    ]);
  };

  // Eliminar equipo
  const removeTeam = (id) => {
    if (teams.length === 1) {
      showToast.warning("Debe haber al menos un equipo");
      return;
    }
    setTeams(teams.filter((team) => team.id !== id));
  };

  // Duplicar equipo
  const duplicateTeam = (teamToDuplicate) => {
    const newId = Math.max(...teams.map((t) => t.id), 0) + 1;
    setTeams([
      ...teams,
      {
        ...teamToDuplicate,
        id: newId,
        teamName: `${teamToDuplicate.teamName} (copia)`,
        image: teamToDuplicate.image,
        imagePreview: teamToDuplicate.imagePreview,
      },
    ]);
    showToast.success("Equipo duplicado");
  };

  // Actualizar campo de un equipo específico
  const updateTeamField = (id, field, value) => {
    setTeams(
      teams.map((team) =>
        team.id === id ? { ...team, [field]: value } : team,
      ),
    );
  };

  const handleImageChange = (id, e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      updateTeamField(id, "image", file);
      updateTeamField(id, "imagePreview", previewUrl);
    }
  };

  const handleAddPartner = (newPartner) => {
    setPartners((prev) => [
      ...prev,
      { label: newPartner.name, value: newPartner.id },
    ]);

    // Agregar el nuevo patrocinador al equipo actual
    if (currentTeamPartnerIndex !== null) {
      const currentPartners =
        teams[currentTeamPartnerIndex].selectedPartners || [];
      updateTeamField(teams[currentTeamPartnerIndex].id, "selectedPartners", [
        ...currentPartners,
        { label: newPartner.name, value: newPartner.id },
      ]);
    }
  };

  const handleSubcategoriesSave = (subcategories) => {
    if (currentTeamSubcategoryIndex !== null) {
      updateTeamField(
        teams[currentTeamSubcategoryIndex].id,
        "selectedSubcategories",
        subcategories,
      );
    }
    setShowSubcategoryPopup(false);
  };

  const validateTeams = () => {
    for (let i = 0; i < teams.length; i++) {
      const team = teams[i];
      if (!team.teamName.trim()) {
        showToast.error(`Equipo ${i + 1}: El nombre del equipo es obligatorio`);
        return false;
      }
      if (!team.city.trim()) {
        showToast.error(`Equipo ${i + 1}: La ciudad es obligatoria`);
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateTeams()) return;

    setIsSubmitting(true);
    let successCount = 0;
    let errorCount = 0;

    for (let i = 0; i < teams.length; i++) {
      const team = teams[i];

      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("team_name", team.teamName);
      formData.append("phone", team.phone || "");
      formData.append("city", team.city);
      formData.append(
        "subcategories",
        JSON.stringify(team.selectedSubcategories || []),
      );

      if (team.selectedPartners && team.selectedPartners.length > 0) {
        team.selectedPartners.forEach((partner) => {
          formData.append("partners[]", partner.value);
        });
      }

      if (team.image) {
        formData.append("picture_url", team.image);
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/teams`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          },
        );

        const data = await response.json();
        if (!response.ok) {
          throw new Error(
            data.message || `Error al crear el equipo ${team.teamName}`,
          );
        }
        successCount++;
      } catch (error) {
        errorCount++;
        console.error(`Error creando equipo ${team.teamName}:`, error);
        showToast.error(`Error al crear "${team.teamName}": ${error.message}`);
      }
    }

    setIsSubmitting(false);

    if (successCount > 0) {
      showToast.success(`${successCount} equipo(s) creado(s) con éxito!`);
      if (errorCount === 0) {
        // Limpiar el formulario si todos fueron exitosos
        setTeams([
          {
            id: 1,
            teamName: "",
            phone: "",
            city: "",
            image: null,
            imagePreview: null,
            selectedSubcategories: [],
            selectedPartners: [],
          },
        ]);
      }
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen my-8">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "90%",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        <div className="text-center text-white mb-8 mt-12">
          <h1 className="text-5xl font-bold">Es hora</h1>
          <p className="text-lg mt-2">De nuevos equipos</p>
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {teams.map((team, index) => (
            <div
              key={team.id}
              className="bg-white p-8 rounded-xl shadow-lg relative"
            >
              {/* Botones de acción para el equipo */}
              <div className="absolute top-4 right-4 flex gap-2">
                <button
                  type="button"
                  onClick={() => duplicateTeam(team)}
                  className="p-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                  title="Duplicar equipo"
                >
                  <HiDuplicate size={16} />
                </button>
                <button
                  type="button"
                  onClick={() => removeTeam(team.id)}
                  className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors"
                  title="Eliminar equipo"
                >
                  <HiTrash size={16} />
                </button>
              </div>

              <h3 className="text-lg font-bold mb-4 text-gray-800">
                Equipo {index + 1}
              </h3>

              {/* Foto del equipo */}
              <div className="flex justify-center mb-4">
                <CircleTorunamentAvatar
                  size={100}
                  imageUrl={team.imagePreview}
                  onImageSelect={(e) => handleImageChange(team.id, e)}
                />
              </div>

              {/* Nombre del equipo - obligatorio */}
              <FieldIcon
                id={`teamName_${team.id}`}
                name="teamName"
                type="text"
                autoComplete="on"
                placeholder="Nombre del equipo"
                value={team.teamName}
                required
                label="Nombre del equipo *"
                onChange={(e) =>
                  updateTeamField(team.id, "teamName", e.target.value)
                }
              />

              {/* Teléfono - opcional */}
              <FieldIcon
                id={`phone_${team.id}`}
                name="phone"
                type="text"
                autoComplete="on"
                placeholder="Teléfono (opcional)"
                value={team.phone}
                required={false}
                label="Teléfono"
                onChange={(e) =>
                  updateTeamField(team.id, "phone", e.target.value)
                }
              />

              {/* Ciudad - obligatorio */}
              <FieldIcon
                id={`city_${team.id}`}
                name="city"
                type="text"
                autoComplete="on"
                placeholder="Ciudad"
                value={team.city}
                required
                label="Ciudad *"
                onChange={(e) =>
                  updateTeamField(team.id, "city", e.target.value)
                }
              />

              {/* Subcategorías */}
              <div>
                <label className="block text-sm font-medium mb-2">
                  Subcategorías
                </label>
                <button
                  type="button"
                  className="bg-blue-500 text-white px-3 py-1 rounded-lg mb-2"
                  onClick={() => {
                    setCurrentTeamSubcategoryIndex(index);
                    setShowSubcategoryPopup(true);
                  }}
                >
                  Configurar Subcategorías
                </button>

                {team.selectedSubcategories &&
                  team.selectedSubcategories.length > 0 && (
                    <p className="mt-2 text-gray-700 text-sm">
                      Subcategorías:{" "}
                      {team.selectedSubcategories
                        .map((sub) =>
                          sub.number && sub.group_name
                            ? `${sub.number} ${sub.group_name}`
                            : sub.number
                              ? sub.number
                              : sub.group_name,
                        )
                        .join(", ")}
                    </p>
                  )}
              </div>

              {/* Patrocinadores */}
              <label className="block text-sm font-medium mb-2">
                Patrocinadores
              </label>
              <Select
                options={partners}
                isMulti
                value={team.selectedPartners || []}
                onChange={(value) =>
                  updateTeamField(team.id, "selectedPartners", value)
                }
                placeholder="Selecciona patrocinadores"
                className="mb-2"
              />
              <button
                type="button"
                className="text-blue-500 text-sm underline mb-2"
                onClick={() => {
                  setCurrentTeamPartnerIndex(index);
                  setShowPartnerPopUp(true);
                }}
              >
                Crear nuevo patrocinador
              </button>
            </div>
          ))}

          {/* Botón para agregar más equipos */}
          <div className="flex justify-center">
            <button
              type="button"
              onClick={addNewTeam}
              className="flex items-center gap-2 px-6 py-3 bg-green-500 text-white rounded-xl hover:bg-green-600 transition-colors font-semibold"
            >
              <HiPlus size={20} />
              Agregar otro equipo
            </button>
          </div>

          {/* Botón de envío */}
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <SendBtn
              label={
                isSubmitting
                  ? "Creando equipos..."
                  : `Crear ${teams.length} equipo(s)`
              }
              type="submit"
              disabled={isSubmitting}
              style={{ backgroundColor: "#E5960E" }}
            />
          </div>
        </form>

        {showPartnerPopUp && (
          <PartnerPopUp
            onClose={() => setShowPartnerPopUp(false)}
            onAddPartner={handleAddPartner}
          />
        )}

        {showSubcategoryPopup && (
          <CategoryPopup
            onClose={() => setShowSubcategoryPopup(false)}
            onSave={handleSubcategoriesSave}
            initialSubcategories={
              currentTeamSubcategoryIndex !== null
                ? teams[currentTeamSubcategoryIndex]?.selectedSubcategories ||
                  []
                : []
            }
          />
        )}
      </div>
    </div>
  );
};

export default CreateTeam;
